<script setup lang="ts">
import { Button } from '@/components/shadcnui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/shadcnui/dialog'

import { useUserStore } from '@/store/useUserStore';
import { AlertTriangle } from 'lucide-vue-next';


const UserStore = useUserStore();

</script>

<template>
  <Dialog v-model:open="UserStore.isProlongationDialogOpen">
    <form>
      <DialogContent class="sm:max-w-[500px]" @interact-outside="(e) => e.preventDefault()">
        <DialogHeader>
          <DialogTitle>
            <div class="flex items-center gap-2">
            <AlertTriangle class="w-6 h-6 text-yellow-500" />
            자동로그아웃안내
            </div>
          </DialogTitle>
          <hr class="my-2 bg-" />
          <DialogDescription style="white-space: pre-line;">
            {{ '자동로그아웃까지 10분 남았습니다.\n2시간 연장하시겠습니까?' }}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose>
            <Button variant="outline">
              Cancel
            </Button>
          </DialogClose>
          <Button type="submit" @click="UserStore.startSession(30); UserStore.isProlongationDialogOpen = false">
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </form>
  </Dialog>
</template>
